import styled from 'styled-components'

export const SearchFieldContainer = styled.div`
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
`
